// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"14":"3f79d7a3","491":"5f0d07d8"}[chunkId] + ".chunk.css";
};